export default {
    data() {
        return {
            valid: {
                mobile: false,
                password: false,
                countryCode: false
            },
            success: {
                mobile: false,
                password: false,
                countryCode: false
            },
            error: {
                mobile: "",
                password: "",
                countryCode: ""
            },
            errorMessages: {
                mobileRequired: {
                    el: "Απαιτείται κινητό χρήστη",
                    en: "User Mobile is required",
                    it: "È richiesto il cellulare dell'utente"
                },
                mobileLength: {
                    el: "Το κινητό χρήστη πρέπει να έχει μήκος μεταξύ 7 και 12 χαρακτήρων.",
                    en: "User Mobile must be between 7 and 12 characters long",
                    it: "Il cellulare dell'utente deve avere una lunghezza compresa tra 7 e 12 caratteri."
                },
                passwordRequired: {
                    el: "Απαιτείται κωδικός πρόσβασης",
                    en: "Password is required",
                    it: "La password è necessaria"
                },
                passwordLength: {
                    el: "Ο κωδικός πρόσβασης πρέπει να αποτελείται από τουλάχιστον 6 χαρακτήρες",
                    en: "Password must be at least 6 characters long",
                    it: "La password deve essere di almeno 6 caratteri"
                },
                countryCodeRequired: {
                    el: "Απαιτείται κωδικός χώρας",
                    en: "Country code is required",
                    it: "Il codice paese è richiesto"
                },
            }
        };
    },

    computed: {
        formValid() {
            return this.mode == 'update' || this.valid.countryCode && this.valid.mobile && this.valid.password
        }
    },

    methods: {
        validateMobile() {
            this.valid.mobile = (this.user.mobile.length >= 7 &&  this.user.mobile.length <= 12);
            this.success.mobile = (this.user.mobile.length >= 7 &&  this.user.mobile.length <= 12);
            if (!this.user.mobile) {
                this.error.mobile = this.errorMessages.mobileRequired[
                    this.lang
                ];
            } else if (this.user.mobile.length < 7 ||  this.user.mobile.length > 12) {
                this.error.mobile = this.errorMessages.mobileLength[this.lang];
            } else {
                this.error.mobile = "";
                this.validateCountryCode();
            }
        },   
        validateCountryCode() {
            this.valid.countryCode = !!this.user.country_id;
            this.success.countryCode = !!this.user.country_id;
            if (!this.user.country_id) {
                this.error.countryCode = this.errorMessages.countryCodeRequired[
                    this.lang
                ];
            } else  {
                this.error.countryCode = "";
            }
        },

        validatePassword() {
            if (!this.user.password) {
                this.error.password = this.errorMessages.passwordRequired[
                    this.lang
                ];
            } else if (this.user.password.length < 6) {
                this.error.password = this.errorMessages.passwordLength[
                    this.lang
                ];
            } else {
                this.error.password = "";
            }
        }
    },

    watch: {
        ["user.mobile"]: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.valid.mobile = (val.length >= 7 && val.length <= 12);
                    this.success.mobile = (val.length >= 7 && val.length <= 12);
                } else {
                    this.valid.mobile = false;
                    this.success.mobile = false;
                }
            }
        },
        ["user.country_id"]: {
            immediate: true,
            handler(val) {
                this.valid.countryCode = !!val;
                this.success.countryCode = !!val;
             
            }
        },
        ["user.password"]: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.valid.password = val.length >= 6;
                    this.success.password = val.length >= 6;
                } else {
                    this.valid.password = false;
                    this.success.password = false;
                }
            }
        },

        resetSuccess(val) {
            if (val) {
                this.success = {
                    mobile: false,
                    password: false,
                    countryCode: false
                };
                this.setResetSuccess(false);
            }
        },

        resetValidation: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.error = {
                        mobile: "",
                        password: "",
                        countryCode: ""
                    };
                    this.setResetValidation(false);
                }
            }
        }
    }
};
